import { PEOPLE_TYPES } from './../../../../modules/extensions-framework/sdk.types';
import { path, pathEq, pathOr, pathSatisfies } from 'ramda';
export const isOnMobileApp = pathEq(['state', 'doxyVersion', 'platform'], 'mobile'); // assuming web by default
export const hasEhrId = pathSatisfies((pid) => !!pid, ['state', 'pid']);
export const getVideoProvider = pathOr('tokbox', [
    'state',
    'vcp',
]); // assuming tokbox by default
export const getStatus = pathOr('available', [
    'state',
    'status',
]); // assuming available by default
export const getCheckedInAt = path(['state', 'checkedInAt']);
export const isDoctor = (person) => person.type === PEOPLE_TYPES.doctor;
export const isPatient = (person) => person.type === PEOPLE_TYPES.patient;
